import React from "react";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[var(--border-subtle)] bg-[var(--bg-elevated)]"
    >
      <div className="container-x py-14 md:py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-lg bg-white/95 flex items-center justify-center overflow-hidden">
              <img
                src="/images/logo.png"
                alt="Aurel Calin Premium"
                className="h-9 w-9 object-contain"
              />
            </div>
            <div>
              <div className="font-display text-lg font-semibold text-[var(--text-primary)] leading-none">
                Aurel Calin <span className="text-brand-blue">Premium</span>
              </div>
              <div className="text-[11px] tracking-[0.22em] uppercase text-[var(--text-muted)] mt-1">
                SC Aurel Calin Premium SRL
              </div>
            </div>
          </div>
          <p className="mt-5 text-[var(--text-secondary)] max-w-md text-sm md:text-[15px] leading-relaxed">
            Renovări și construcții complete pentru case și apartamente în
            Constanța și împrejurimi. 14 ani experiență · peste 400 de lucrări
            finalizate.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold">
            Contact
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a
                href="tel:0746329111"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-[var(--text-primary)] hover:text-brand-gold transition-colors"
              >
                <Phone className="h-4 w-4 text-brand-blue" />
                0746 329 111
              </a>
            </li>
            <li>
              <a
                href="mailto:aurelcalin32@gmail.com"
                data-testid="footer-email"
                className="flex items-center gap-3 text-[var(--text-primary)] hover:text-brand-gold transition-colors break-all"
              >
                <Mail className="h-4 w-4 text-brand-blue flex-shrink-0" />
                aurelcalin32@gmail.com
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/40746329111"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="flex items-center gap-3 text-[var(--text-primary)] hover:text-brand-gold transition-colors"
              >
                <MessageCircle className="h-4 w-4 text-brand-blue" />
                WhatsApp
              </a>
            </li>
            <li className="flex items-center gap-3 text-[var(--text-secondary)]">
              <MapPin className="h-4 w-4 text-brand-blue flex-shrink-0" />
              Constanța și împrejurimi
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold">
            Navigare
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              ["servicii", "Servicii"],
              ["galerie", "Galerie"],
              ["despre", "Despre noi"],
              ["recenzii", "Recenzii"],
              ["contact", "Contact"],
            ].map(([id, label]) => (
              <li key={id}>
                <a
                  href={`#${id}`}
                  className="text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-[var(--border-subtle)]">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[var(--text-muted)]">
          <div>
            © {new Date().getFullYear()} SC Aurel Calin Premium SRL. Toate
            drepturile rezervate.
          </div>
          <div>Renovări construcții · Constanța</div>
        </div>
      </div>
    </footer>
  );
}
